export const OTP_LENGTH = 4;
export const STUB_OTP = "1234";
export const OTP_PATTERN = /^\d{4}$/;

export function sanitizeOtpInput(value, maxLength = OTP_LENGTH) {
  return String(value || "")
    .replace(/\D/g, "")
    .slice(0, maxLength);
}

export function isValidOtpInput(value) {
  return OTP_PATTERN.test(String(value || "").trim());
}

export function otpDigitsForDisplay(value) {
  const otp = String(value || "").trim();
  if (!otp) {
    return Array.from({ length: OTP_LENGTH }, () => "-");
  }
  const digits = otp.split("").slice(0, OTP_LENGTH);
  while (digits.length < OTP_LENGTH) digits.push("-");
  return digits;
}
